export const evidenceKeys = {
  all: ["evidence"],
  records: ["evidence", "record"],
  recordsOf: (itemId: string) => ["evidence", "record", itemId] as const,
  record: (itemId: string, version: number | undefined, communication: number | undefined) =>
    ["evidence", "record", itemId, version ?? null, communication ?? null] as const,
  translation: (itemId: string, language: "en" | "de", version: number | undefined) =>
    ["evidence", "translation", itemId, language, version ?? null] as const,
  preview: (...key: unknown[]) => ["evidence", "preview", ...key] as const,
  copyCandidates: (itemId: string) => ["evidence", "copy-candidates", itemId] as const,
  policies: ["evidence", "policies"],
  policyPreview: (dimensions: unknown) => ["evidence", "policies", "preview", dimensions] as const,
  optionalChecks: ["evidence", "optional-checks"],
  optionalCheckPreview: (kind: string, values: unknown) =>
    ["evidence", "optional-checks", "preview", kind, values] as const,
  search: (params: unknown, limit: number) => ["search", params, limit] as const,
} as const;
